const pop_up = () => {
    $('.pop-up-module .cta-arrow').on('click', function() {
        $(this).parent().next('.pop-up-modal').fadeIn();
        $('html').css({'overflow': 'hidden'});
    });

    $('.pop-up-module .pop-up-modal .close').on('click', function() {
        $(this).parent().parent().fadeOut();
        $('html').css({'overflow': ''});
    });

    $('.promotion-popup-close').on('click', function() {
        $(this).parent().parent().fadeOut();
    });

    popupposition();

    function popupposition() {
        $('.pop-up-module').each(function(i){

            var popupheight = $(this).find('.pop-up-cta').outerHeight();
    
            $(this).prev().css('padding-bottom', (popupheight+75)/2);
            $(this).next().css('padding-top', (popupheight+75)/2);
            $(this).find('.pop-up-cta').css('top', -popupheight/2);
        })
    }

    // When the window is resized...
    $(window).smartresize(function(){   
        popupposition();
    })
    

}

(function($,sr){

// debouncing function from John Hann
// http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
var debounce = function (func, threshold, execAsap) {
    var timeout;

    return function debounced () {
        var obj = this, args = arguments;
        function delayed () {
            if (!execAsap)
                func.apply(obj, args);
            timeout = null;
        };

        if (timeout)
            clearTimeout(timeout);
        else if (execAsap)
            func.apply(obj, args);

        timeout = setTimeout(delayed, threshold || 100);
    };
}
// smartresize 
jQuery.fn[sr] = function(fn){  return fn ? this.on('resize', debounce(fn)) : this.trigger(sr); };

})(jQuery,'smartresize');

export default pop_up;